import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { getBackgroundImageUrl } from "../../../../helpers/navigationBackgroundImageResolver";
import { useGetAppDownloadUrl } from "../../../../utils/hooks/useGetAppDownloadUrl";
import { withTranslation } from "@template/components/translation";
import LazyImage from "../../../LazyImage";
import styles from "./index.css";

const cx = classnames.bind(styles);

const SquareItem = ({
  className,
  item,
  saveNavigationItem,
  countryCode,
  formatTranslation
}) => {
  const { appDownloadUrl, isLoading } = useGetAppDownloadUrl({
    countryCode,
    ctaRef: "sideNavigation square item|our apps"
  });

  const [link, setLink] = useState(item?.link);

  useEffect(() => {
    const label = formatTranslation("app_download_cta");
    const normalizedLabel = label.toLowerCase().split(" ")[0];
    const itemLabel = item?.label ? item.label.toLowerCase() : "";
    if (itemLabel.includes(normalizedLabel) && appDownloadUrl && !isLoading) {
      setLink(appDownloadUrl);
    }
  }, [item?.label, formatTranslation, appDownloadUrl, isLoading]);

  const target = item.linkType === "external" ? "_blank" : null;

  return (
    <li className={cx(styles.container, className)} data-testid="square-item">
      <a
        data-navid={item.id}
        className={styles.link}
        href={link}
        ref={saveNavigationItem}
        target={target}
      >
        {item.smallAndMediumImageUrl && (
          <LazyImage
            aria-hidden="true"
            className={styles.image}
            role="presentation"
            src={getBackgroundImageUrl(item.smallAndMediumImageUrl, 320)}
            tag={"div"}
          />
        )}
        <p
          className={cx(styles.label, {
            [styles.label__sale]: item.smallAndMediumStyleType === "sale"
          })}
        >
          {item.label}
        </p>
      </a>
    </li>
  );
};

SquareItem.propTypes = {
  className: PropTypes.string,
  item: PropTypes.any,
  saveNavigationItem: PropTypes.func.isRequired,
  countryCode: PropTypes.string,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(SquareItem);
